import service from "@/store/services/empresas-service";

const state = {
  list: {},
  empresa: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, empresa) => {
    state.empresa = empresa;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((empresa) => {
      commit("SET_RESOURCE", empresa);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((empresa) => {
      commit("SET_RESOURCE", empresa);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((empresa) => {
      commit("SET_RESOURCE", empresa);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  empresa: (state) => state.empresa,
  dropdown: (state) => {
    /*   state.list.map((empresa) => console.log(empresa)); */
    return state.list.map((empresa) => ({
      id: empresa.id,
      alias: empresa.alias,
    }));
  },
};

const empresas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default empresas;
